import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ViewOpportunites = Loadable(
	lazy(() =>
		import("./opportunites").then(({ ViewOpportunites }) => ({
			default: ViewOpportunites,
		}))
	)
);
const ManageOpportunity = Loadable(
	lazy(() =>
		import("./CreateOppurtunity/manageOpportunites").then(
			({ ManageOpportunity }) => ({
				default: ManageOpportunity,
			})
		)
	)
);

export const opportunityRoutes = [
	{
		path: "/venue",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.OPPORTUNITY]}
			>
				<ViewOpportunites />
			</AuthorizedRoute>
		),
	},
	{
		path: "/venue/manage",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.OPPORTUNITY]}
			>
				<ManageOpportunity />
			</AuthorizedRoute>
		),
	},
	{
		path: "/venue/manage/:oppId",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.OPPORTUNITY]}
			>
				<ManageOpportunity />
			</AuthorizedRoute>
		),
	},
];
